import httpClient from "../httpClient";

const END_POINT = "/notification";

const getAllNotifications = () => httpClient.get(`${END_POINT}/all`);
const getNotifications = () => httpClient.get(`${END_POINT}/`);
const deleteNotification = id => httpClient.put(`${END_POINT}/${id}`);
const sendByNotificationId = id => httpClient.post(`${END_POINT}/${id}`);
const createNotification = (payload) => httpClient.post(`${END_POINT}/toRecipients`, payload);

export { getNotifications, deleteNotification, createNotification, getAllNotifications, sendByNotificationId };
